<template>
  <div class="loader-wrapper" v-if="loading">
    <div class="backdrop">
      <div class="loader-container">
        <div class="loader"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Loader',
  computed: {
    ...mapState(['loading'])
  }
}
</script>

<style scoped>
.loader {
  content: '';
  display: block;
  height: 50px;
  width: 50px;
  -webkit-animation: spin .8s infinite linear;
  animation: spin .8s infinite linear;
  border: 4px black solid;
  border-left-color: white;
  border-top-color: white;
  border-radius: 100%;
}
.loader-wrapper {
  z-index: 10001;
}
.backdrop {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  --tw-bg-opacity: 0.95;
  overflow-y: auto;
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  z-index: 10001;
}
.loader-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  min-height: 100vh;
  text-align: center;
}
@-webkit-keyframes spin {
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes spin {
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
